import path from "path";

import type { IncomingMessage, ServerResponse } from "http";
import type { AddressInfo } from "net";

export function resolveAbsolutePath(p: string): string {
  return path.isAbsolute(p) ? p : path.resolve(process.cwd(), p);
}

export function toPosixPath(p: string): string {
  return p.replace(/\\/g, "/");
}

export interface ServerAddress {
  protocol: string;
  host: string;
  port: number;
}

export function getServerAddress(
  address: AddressInfo,
  isHttps: boolean,
): ServerAddress {
  return {
    protocol: isHttps ? "https" : "http",
    host:
      address.address === "::" || address.address === "0.0.0.0"
        ? "localhost"
        : address.address,
    port: address.port,
  };
}

export function sendJson(
  res: ServerResponse,
  data: unknown,
  status = 200,
): void {
  res.setHeader("Content-Type", "application/json; charset=utf-8");
  res.statusCode = status;
  res.end(typeof data === "string" ? data : JSON.stringify(data));
}

export function sendError(
  res: ServerResponse,
  message: string,
  status = 500,
): void {
  sendJson(res, { error: message }, status);
}

const MAX_BODY_SIZE = 10 * 1024 * 1024; // 10MB

export function readBody(req: IncomingMessage): Promise<string> {
  return new Promise((resolve, reject) => {
    const chunks: Buffer[] = [];
    let totalSize = 0;
    req.on("data", (chunk: Buffer) => {
      totalSize += chunk.length;
      if (totalSize > MAX_BODY_SIZE) {
        reject(new Error("Request body too large"));
        req.destroy();
        return;
      }
      chunks.push(chunk);
    });
    req.on("end", () => resolve(Buffer.concat(chunks).toString("utf-8")));
    req.on("error", reject);
  });
}
